window.addEventListener('load', () => {
  const header = document.querySelector('[data-item="header"]')
  const main = document.querySelector('main')

  if (header && main) {
    if (!header.classList.contains('main')) {
      main.style.paddingTop = `calc(var(--bw__sizer) * ${
        header.getBoundingClientRect().height
      })`
    }

    main.style.setProperty(
      '--header-height',
      `calc(var(--bw__sizer) * ${header.getBoundingClientRect().height})`,
    )

    const headerTop = header.getBoundingClientRect().top + window.scrollY

    window.addEventListener('scroll', () => {
      if (headerTop + 200 <= window.scrollY) {
        header.classList.add('scrolled')
      } else {
        header.classList.remove('scrolled')
      }
    })
  }
})
